import { Component } from '@angular/core';

@Component({
    selector: 'nm-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {

    errorMessage: string | null = null;
    showErrorFlag: boolean = false;

    showError(errorMessage: string) {
        this.errorMessage = errorMessage;
        this.showErrorFlag = true;
    }

    hideError() {
        this.showErrorFlag = false;
    }
}
